import Vue from 'vue'
import ValoresRepository from '@/services/ValoresRepository'

export default {
  namespaced: true,
  state: {
    //fichas Agricolas
    fichaAgricola: { nombre: 'Elija Ficha', idFichaAgricola: null },
    listaFichaAgricola: [],
    //ficha Ganadera
    fichaGanadera: { nombre: 'Elija Ficha', idFichaGanadera: null },
    parcelas: []
  },
  getters: {
    //fichas Agricolas
    getFichaAgricola: (state) => (idFichaAgricola) => {
      return state.listaFichaAgricola.find(fichaAgricola => fichaAgricola.idFichaAgricola === idFichaAgricola)
    },

    filteredListaFichaAgricola(state) {
      if (state.fichaAgricola) {
        return state.listaFichaAgricola.filter(x => x.idFichaAgricola !== state.fichaAgricola.idFichaAgricola)
      }
    },
    isSuperficieSet(state) {
      if (state.fichaGanadera.idFichaGanadera !== null && state.parcelas.length > 0) {
        return state.fichaGanadera.superficie !== null && state.fichaGanadera.superficie > 0
      }
      return false
    },

    // Used in router
    isFichaAgricolaSet(state) {
      return state.fichaAgricola.idFichaAgricola !== null
    },

    //ficha Ganadera
    isFichaGanaderaSet(state) {
      return state.fichaGanadera.idFichaGanadera !== null
    },

    getParcela: (state) => (idParcelaGanadera) => {
      return state.parcelas.find(parcela => parcela.idParcelaGanadera === idParcelaGanadera)
    },

    isParcelasSet(state) {
      return state.parcelas.length !== 0
    },
  },
  mutations: {
    //Fichas Agricolas
    setListaFichaAgricola(state, listaFichaAgricola) {
      state.listaFichaAgricola = listaFichaAgricola.map(fichaAgricola => {
        let nombreCultivo = fichaAgricola.variedad.cultivo.nombre
        let nombreVariedad = fichaAgricola.variedad.nombre
        let cultivoVariedad = nombreCultivo === nombreVariedad ? nombreCultivo : nombreCultivo + ' ' + nombreVariedad
        fichaAgricola.cultivoVariedad = cultivoVariedad
        fichaAgricola.superficieFormated = Vue.filter('fhDecimalNumber')(fichaAgricola.superficie)
        return fichaAgricola
      })
    },

    setFichaAgricola(state, idFichaAgricola) {
      let index = state.listaFichaAgricola.map(x => x.idFichaAgricola).indexOf(idFichaAgricola)
      state.fichaAgricola = state.listaFichaAgricola[index]
      localStorage.setItem('selectedFichaAgricola', JSON.stringify(state.fichaAgricola))
    },

    clearFichaAgricola(state) {
      state.fichaAgricola = { nombre: 'Elija Ficha', idFichaAgricola: null }
      state.listaFichaAgricola = []
    },

    restoreFichaAgricola(state) {
      let selectedFichaAgricola = localStorage.getItem('selectedFichaAgricola')

      if (selectedFichaAgricola) {
        let fichaAgricola = JSON.parse(selectedFichaAgricola)
        // Only restore if fichaAgricola is in listaFichaAgricola
        if (state.listaFichaAgricola.some(ficha => ficha.idFichaAgricola === fichaAgricola.idFichaAgricola)) {
          state.fichaAgricola = fichaAgricola
        } else {
          localStorage.removeItem('selectedFichaAgricola')
        }
      }
    },

    //Ficha Ganadera
    setFichaGanadera(state, fichaGanadera) {
      if (Array.isArray(fichaGanadera) &&
        fichaGanadera.length === 0) {
        state.fichaGanadera = { nombre: 'Elija Ficha', idFichaGanadera: null }
      } else {
        state.fichaGanadera = fichaGanadera
      }
      state.parcelas = fichaGanadera.parcelas ? fichaGanadera.parcelas : []
      localStorage.setItem('selectedFichaGanadera', JSON.stringify(state.fichaGanadera))
    },

    clearFichaGanadera(state) {
      state.fichaGanadera = { nombre: 'Elija Ficha', idFichaGanadera: null }
      state.parcelas = []
    },

  },
  actions: {
    //fichas Agricolas
    async fetchListaFichaAgricola({ state, commit, rootState }) {
      if (state.listaFichaAgricola && state.listaFichaAgricola.length > 0) {
        return
      }

      let idEstablecimiento = rootState.establecimientos.establecimiento.idEstablecimiento
      let idGrupoExplotacion = rootState.establecimientos.currentGrupoExplotacion.idGrupoExplotacion

      let idTemporada = rootState.temporada.temporada?.idTemporada

      if (idEstablecimiento !== 0 && idGrupoExplotacion !== 0 && idTemporada && idTemporada !== 0) {
        let listaFichaAgricola = await ValoresRepository.listaFichaAgricola(idEstablecimiento, idGrupoExplotacion, idTemporada) || []
        commit('setListaFichaAgricola', listaFichaAgricola)
      }
    },

    async setFichaAgricola({ commit, dispatch }, idFichaAgricola) {
      commit('setFichaAgricola', idFichaAgricola)

      await dispatch('trabajos/clearTrabajoFicha', null, { root: true })
      await dispatch('rendimientoCosecha/clearRendimientoCosecha', null, { root: true })
      await dispatch('precipitacion/clearPrecipitacion', null, { root: true })
      await dispatch('alquiler/clearAlquiler', null, { root: true })
    },

    async clearFichaAgricola({ commit, dispatch }) {
      commit('clearFichaAgricola')

      await dispatch('trabajos/clearTrabajoFicha', null, { root: true })
      await dispatch('rendimientoCosecha/clearRendimientoCosecha', null, { root: true })
      await dispatch('precipitacion/clearPrecipitacion', null, { root: true })
      await dispatch('alquiler/clearAlquiler', null, { root: true })
    },

    async restoreFichaAgricola({ commit, dispatch }) {
      await dispatch('fetchListaFichaAgricola')

      commit('restoreFichaAgricola')
    },

    //ficha Ganadera
    async fetchFichaGanadera({ state, commit, rootState, rootGetters }) {
      if (state.fichaGanadera.idFichaGanadera !== null && state.fichaGanadera.idFichaGanadera !== 0 || !rootGetters['establecimientos/hasCategoriaGanaderia']) {
        return
      }

      let idEstablecimiento = rootState.establecimientos.establecimiento.idEstablecimiento
      let idGrupoExplotacion = rootGetters['establecimientos/ganaderiaExplotacion'].idGrupoExplotacion
      let idTemporada = rootState.temporada.temporada?.idTemporada

      if (idEstablecimiento !== 0 && idGrupoExplotacion !== 0 && idTemporada !== null && idTemporada !== undefined && idTemporada !== 0) {
        let fichaGanadera = await ValoresRepository.fichaGanadera(idEstablecimiento, idGrupoExplotacion, idTemporada) || []
        commit('setFichaGanadera', fichaGanadera)
      }
    },

    clearFichaGanadera({ commit }) {
      commit('clearFichaGanadera')
    },

  }
}
